import Text from 'components/Text/Text';
import { useCompareFormData } from 'hooks/useCompareFormData';
import React, { useContext } from 'react';
import { IEditVideoContext, EditVideoContext } from '../../../../../../editVideoState/editVideoContext';
import { Form } from 'antd';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import classNames from 'classnames';
import style from './BtnBlock.module.scss';

const BtnBlock: React.FC = () => {
	const {
		changeTypeOfModalWindow,
		IDSelectedStudio,
		name,
		IDSelectedCategory,
		IDsSelectedLanguages,
		videoFileData,
		iconFileId,
		iconFilePath,
		translations,
		initialFormData,
	} = useContext<IEditVideoContext>(EditVideoContext);
	const containerClasses = classNames(style.container, {
		[style.visible]:
			IDSelectedStudio || name || IDSelectedCategory || IDsSelectedLanguages.length || videoFileData.fileId,
	});

	const compareVideoFile = () => {
		if (videoFileData.fileId) {
			return videoFileData.fileId; // if uploaded new file
		}
		return { fileId: '', fileName: '', fileHash: null }; // if no file
	};

	const currentFormData = {
		IDSelectedStudio,
		name,
		IDSelectedCategory,
		IDsSelectedLanguages,
		translations,
		videoFileData: compareVideoFile(),
		iconFilePath: iconFileId || iconFilePath || null,
	};

	const isEqualFormData = useCompareFormData(initialFormData, currentFormData);

	const handleCancel = () => {
		changeTypeOfModalWindow('toConfirmFieldsClearing');
	};

	return (
		<Form.Item>
			<div className={containerClasses} data-test="BtnBlock">
				<Button
					className={style.cancelBtn}
					theme="outlined"
					onClick={handleCancel}
					icon={
						<svg className={style.icon}>
							<use xlinkHref={`${breadcrumbs}#resetIcon`} />
						</svg>
					}>
					<Text translationNameSpace="form" translationKey="cancelButton" asFragment={true} />
				</Button>
				<Button className={style.saveBtn} theme="primaryBlue" type="submit" disabled={isEqualFormData}>
					<Text translationNameSpace="form" translationKey="saveButton" asFragment={true} />
				</Button>
			</div>
		</Form.Item>
	);
};

export default BtnBlock;
